import { Auth } from 'aws-amplify';

import { debugLog } from "./app";

export async function getDeltaId() {
  let user = await Auth.currentAuthenticatedUser();
  debugLog('getDeltaId user: ', user);
  return user.deltaId;
}

export async function getSession() {
  try {
    if(await Auth.currentSession())
      return true;
  }
  catch (e) {
    // squelch!
  }

  return false;
}

export function buildUserFromStudentService(student) {
  if(typeof student !== 'object')
    return { complete: false, updating: false };
  const {
    address1,
    address2,
    city,
    deltaId,
    state,
    zip,
    birthDate,
    email,
    firstName,
    lastName,
    middleName,
    ethnicity,
    gender,
    emergency,
    cell,
    work,
    home } = student;
  const address = {
    address1,
    address2,
    city,
    state,
    zip
  };
  const name = {
    firstName,
    lastName,
    middleName,
    displayName: `${firstName} ${lastName}`
  };
  const phones = {
    home,
    emergency,
    cell,
    work
  };
  return {
    birthDate,
    deltaId,
    email,
    ethnicity,
    gender,
    address,
    name,
    phones,
    complete: student.latest,
    updating: !student.latest
  }
}